// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"dfdb5ca3","54":"8a873502","87":"8c96d0f8","168":"b296e63a","206":"a63b2113","451":"37407dca","729":"d5c6169d","818":"610827d3"}[chunkId] + ".chunk.js";
};